<template>
    <div class="product-module">
        <!--        {# <div class="favourite">-->
        <!--        <a href="#">-->

        <!--            <svg class="mb-2 heart" width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--                <path class="bg" d="M24.9688 13.0117C27.8125 10.0664 27.6602 5.19141 24.4609 2.44922C21.7188 0.0625 17.5039 0.519531 14.9648 3.10938L14 4.17578L12.9844 3.10938C10.4453 0.519531 6.23047 0.0625 3.48828 2.44922C0.289062 5.19141 0.136719 10.0664 2.98047 13.0117L12.7812 23.168C13.4414 23.8281 14.5078 23.8281 15.1172 23.168L24.9688 13.0117Z" fill="white"/>-->
        <!--                <path class="stroke" d="M24.9688 13.0117L25.6865 13.708L25.6882 13.7063L24.9688 13.0117ZM24.4609 2.44922L23.8044 3.20355L23.8101 3.20848L24.4609 2.44922ZM14.9648 3.10938L14.2508 2.4093L14.2367 2.42361L14.2233 2.43846L14.9648 3.10938ZM14 4.17578L13.2759 4.86544L14.0188 5.64551L14.7415 4.84669L14 4.17578ZM12.9844 3.10938L13.7085 2.41972L13.7035 2.41448L13.6984 2.4093L12.9844 3.10938ZM3.48828 2.44922L4.13909 3.2085L4.14481 3.20352L3.48828 2.44922ZM2.98047 13.0117L3.70006 12.3173L3.69987 12.3171L2.98047 13.0117ZM12.7812 23.168L12.0617 23.8624L12.0678 23.8688L12.0741 23.8751L12.7812 23.168ZM15.1172 23.168L14.3994 22.4717L14.3908 22.4806L14.3824 22.4897L15.1172 23.168ZM25.6882 13.7063C28.9257 10.3531 28.7545 4.8123 25.1117 1.68996L23.8101 3.20848C26.5659 5.57051 26.6993 9.77968 24.2493 12.3171L25.6882 13.7063ZM25.1175 1.69491C21.9196 -1.08838 17.1056 -0.502658 14.2508 2.4093L15.6789 3.80945C17.9022 1.54172 21.5179 1.21338 23.8044 3.20352L25.1175 1.69491ZM14.2233 2.43846L13.2585 3.50487L14.7415 4.84669L15.7064 3.78029L14.2233 2.43846ZM14.7241 3.48613L13.7085 2.41972L12.2602 3.79903L13.2759 4.86544L14.7241 3.48613ZM13.6984 2.4093C10.8436 -0.502658 6.02958 -1.08838 2.83176 1.69491L4.14481 3.20352C6.43136 1.21338 10.047 1.54172 12.2703 3.80945L13.6984 2.4093ZM2.83749 1.68996C-0.805237 4.8123 -0.976483 10.3531 2.26107 13.7063L3.69987 12.3171C1.24992 9.77968 1.38336 5.57051 4.13907 3.20848L2.83749 1.68996ZM2.26088 13.7061L12.0617 23.8624L13.5008 22.4736L3.70006 12.3173L2.26088 13.7061ZM12.0741 23.8751C13.1084 24.9094 14.8315 24.9517 15.852 23.8462L14.3824 22.4897C14.1841 22.7045 13.7744 22.7469 13.4884 22.4609L12.0741 23.8751ZM15.835 23.8642L25.6865 13.708L24.251 12.3155L14.3994 22.4717L15.835 23.8642Z" fill="#333740"/>-->
        <!--            </svg>-->

        <!--            <span class="text-xs font-geomLight text-black uppercase block text-center">Favourites</span>-->
        <!--        </a>-->
        <!--    </div> #}-->

        <div class="product-module__wrapper">
            <a :href="model.uri">
                <div class="module__top flex justify-between items-center p-4">
                    <div class="flex justify-start items-center">
                        <p
                            v-if="model.numberOfSeats"
                            class="flex justify-start items-center text-offBlack mb-0 mr-6"
                        >
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fal"
                                data-icon="user"
                                class="mr-2 w-3 svg-inline--fa fa-user fa-w-14"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                                ></path></svg
                            >{{ model.numberOfSeats }}
                        </p>

                        <p
                            v-if="model.waterCapacity"
                            class="flex justify-start items-center text-offBlack mb-0"
                        >
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fal"
                                data-icon="droplet"
                                class="mr-2 w-5 svg-inline--fa fa-droplet fa-w-20"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 640 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M192 400C200.8 400 208 407.2 208 416C208 424.8 200.8 432 192 432C130.1 432 80 381.9 80 319.1C80 311.2 87.16 303.1 96 303.1C104.8 303.1 112 311.2 112 319.1C112 364.2 147.8 400 192 400zM368 319.1C368 417.2 289.2 496 192 496C94.8 496 16 417.2 16 319.1C16 245.9 118.3 89.43 166.9 19.3C179.2 1.585 204.8 1.585 217.1 19.3C265.7 89.43 368 245.9 368 319.1zM321.5 263.4C311.8 238.9 298.2 211.6 282.8 183.7C252.4 128.8 216.1 74.13 192 39.32C167.9 74.13 131.6 128.8 101.2 183.7C85.77 211.6 72.17 238.9 62.51 263.4C52.57 288.5 48 307.6 48 319.1C48 399.5 112.5 464 192 464C271.5 464 336 399.5 336 319.1C336 307.6 331.4 288.5 321.5 263.4V263.4z"
                                /></svg
                            >{{ model.waterCapacity }}
                        </p>
                    </div>

                    <p
                        v-if="model.lengthOfTheUnit"
                        class="flex justify-start items-center text-offBlack"
                    >
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fal"
                            data-icon="arrows-h"
                            class="mr-2 w-5 svg-inline--fa fa-arrows-h fa-w-16"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M399.959 170.585c-4.686 4.686-4.686 12.284 0 16.971L451.887 239H60.113l51.928-51.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-84.485 84c-4.686 4.686-4.686 12.284 0 16.971l84.485 84c4.686 4.686 12.284 4.686 16.97 0l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273h391.773l-51.928 51.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l84.485-84c4.687-4.686 4.687-12.284 0-16.971l-84.485-84c-4.686-4.686-12.284-4.686-16.97 0l-7.07 7.071z"
                            ></path></svg
                        >{{ model.lengthOfTheUnit }} mm
                    </p>
                </div>
            </a>

            <div class="relative module__center overflow-hidden">
                <a :href="model.uri">
                    <div class="w-full aspect-[3/2] object-cover">
                        <img
                            class="absolute inset-0 mx-auto my-auto p-5"
                            :src="chooseImage() || model.image"
                            :alt="model.title"
                        />
                    </div>
                </a>
            </div>

            <div class="module__bottom flex">
                <div class="product-name-price p-4 w-2/3">
                    <a :href="model.uri">
                        <div class="lead text-offBlack mb-1">
                            <p>{{ model.title }}</p>
                        </div>
                        <div
                            class="flex justify-start items-center text-offBlack"
                        >
                            <p class="sml mb-0 mr-2">From</p>
                            <p class="tracking-wider">
                                {{
                                    model.fromPrice === null
                                        ? "POA"
                                        : "$" +
                                          Number(
                                              model.fromPrice
                                          ).toLocaleString()
                                }}
                            </p>
                        </div>
                    </a>
                </div>
                <Favouritesbutton
                    :id="model.id"
                    :title="model.title"
                    :image="chooseImage()"
                ></Favouritesbutton>
            </div>
        </div>
    </div>
</template>

<script>
import State from "./State";
import { toRefs } from "vue";
import FavouritesState, { addModelToFavourites } from "../favourites/State";
import Favouritesbutton from "../Favouritesbutton.vue";

export default {
    props: {
        model: Object,
    },
    components: {
        Favouritesbutton,
    },

    setup(props) {
        const { idArray } = toRefs(FavouritesState);
        function chooseImage() {
            if (State.imageFloorPlans) return props.model.floorPlan;
            return props.model.image;
        }
        return { chooseImage, addModelToFavourites, idArray };
    },
};
</script>
